<template>
	<div v-if="item.price_custom > 0" class="price" :class="{'uau': item.selected_price == 'uau', 'uaump': item.selected_price == 'uaump', 'inactive': item.price_custom_prices_cart && item.price_custom_prices_cart_expire}">
		<template v-if="item?.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom) && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
			<!--
			<div class="current-price red"><BaseUtilsFormatCurrency :wrap="true" :price="100.00" /></div>
			<div class="old-price special">
				<span><BaseUtilsFormatCurrency :price="50.00" /></span>
			</div>
			<div class="cd-price-label red"><BaseCmsLabel code="permanently_low_price_tooltip" tag="span" /></div>
			<span class="cd-old-price-icon">
				<span class="cd-old-price-tooltip">
					<span class="cd-old-price-tooltip-close"></span>
					<BaseCmsLabel code="permanently_low_price_tooltip" tag="span" />
				</span>
			</span>
			-->
			<div class="current-price red"><BaseUtilsFormatCurrency :wrap="true" :price="item.price_custom" /></div>
			<div class="old-price special">
				<span><BaseUtilsFormatCurrency :price="item.basic_price_custom" /></span>
				<!--
				<span class="cd-old-price-icon">
					<span class="cd-old-price-tooltip">
						<span class="cd-old-price-tooltip-close"></span>
						<BaseCmsLabel code="permanently_low_price_tooltip" tag="span" />
					</span>
				</span>
				-->
			</div>
			<div class="cd-price-label red"><BaseCmsLabel code="permanently_low_price_tooltip" tag="span" /></div>
		</template>
		<template v-if="item.selected_price == 'promotion2' && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
			<!--
			<div class="current-price"><BaseUtilsFormatCurrency :wrap="true" :price="1200.50" /></div>
			<div class="price-badges">
				<div class="badge yellow">
					<BaseCmsLabel code="prihranek_promotion" />: <strong><BaseUtilsFormatCurrency :price="500.50" /></strong>
				</div>
			</div>
			-->
			<div class="current-price"><BaseUtilsFormatCurrency :wrap="true" :price="item.price_custom" /></div>
			<div v-if="item.price_custom < item.basic_price_custom && props.showBadges" class="price-badges">
				<div class="badge yellow">
					<BaseCmsLabel code="prihranek_promotion" />: <strong><BaseUtilsFormatCurrency :price="item.basic_price_custom - item.price_custom" /></strong>
				</div>
			</div>
		</template>
		<template v-else-if="(item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom) && ((!item.loyalty_price_custom || isLoyalty == false) || (isLoyalty == true && item.loyalty_price_custom && item.price_custom < item.loyalty_price_custom))">
			<!--
			<div class="current-price red"><BaseUtilsFormatCurrency :price="100.00" /></div>
			<div class="old-price"><BaseUtilsFormatCurrency :price="50.00" /></div>
			<div class="price-badges">
				<div class="badge red">
					<BaseCmsLabel code="prihranek" /> <strong><BaseUtilsFormatCurrency :price="50.00" /></strong>
				</div>
			</div>
			-->
			<div class="current-price red"><BaseUtilsFormatCurrency :wrap="true" :price="item.price_custom" /></div>
			<div class="old-price"><BaseUtilsFormatCurrency :price="item.basic_price_custom" /></div>
			<!--
			<div v-if="(item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom) && props.showBadges" class="price-badges">
				<div class="badge red">
					<BaseCmsLabel code="prihranek" /> <strong><BaseUtilsFormatCurrency :price="item.basic_price_custom - item.price_custom" /></strong>
				</div>
			</div>
			-->
		</template>
		<template v-else-if="isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.basic_price_custom">
			<!--
			<div class="cd-price-label"><BaseCmsLabel code="klubska_cena" /></div>
			<div class="current-price blue"><BaseUtilsFormatCurrency :wrap="true" :price="100.00" /></div>
			<div class="old-price">
				<BaseUtilsFormatCurrency :price="50.00" />
			</div>
			<div class="price-badges">
				<div class="badge blue">
					<BaseCmsLabel code="klubski_prihranek" /> <BaseUtilsFormatCurrency :price="50.00" />
				</div>
			</div>
			-->
			<div class="cd-price-label"><BaseCmsLabel code="klubska_cena" /></div>
			<div class="current-price blue"><BaseUtilsFormatCurrency :wrap="true" :price="item.loyalty_price_custom" /></div>
			<div class="old-price">
				<template v-if="item.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)"><BaseUtilsFormatCurrency :price="item.price_custom" /></template>
				<template v-else><BaseUtilsFormatCurrency :price="item.basic_price_custom" /></template>
			</div>
			<div v-if="(item.loyalty_price_custom < item.basic_price_custom) && props.showBadges" class="price-badges">
				<div class="badge blue">
					<BaseCmsLabel code="klubski_prihranek" />&nbsp;
					<span v-if="config?.selected_price == 'recommended' && (item.discount_percent_custom > 0 || item.price_custom < item.basic_price_custom)"><BaseUtilsFormatCurrency :price="item.price_custom - item.loyalty_price_custom" /></span>
					<span v-else><BaseUtilsFormatCurrency :price="item.basic_price_custom - item.loyalty_price_custom" /></span>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="current-price"><BaseUtilsFormatCurrency :price="item.price_custom" :wrap="true" /></div>
		</template>
	</div>
</template>

<script setup>
	const props = defineProps({
		item: {
			type: Object,
			required: true
		},
		showBadges: {
			type: Boolean,
			default: true
		}
	});

	const {isLoyalty} = useProductData(props.item);
</script>

<style lang="less" scoped>
	.price{
		display: flex; align-items: flex-end; padding-top: 16px; gap: 6px; line-height: 1; flex-wrap: wrap;
		@media (max-width: @t){flex-wrap: wrap; row-gap: 2px;}
		@media (max-width: @m){padding-top: 10px;}
		.red{color: var(--errorColor);}
		&.uau{color: var(--orange);}
		&.uaump{color: var(--uaump);}
	}
	.cd-price-label{width: 100%; font-size: 13px; line-height: 1.3;}
	.current-price{
		font-weight: 700; font-size: 22px;
		@media (max-width: @t){font-size: 16px;}
		.p-comma{display: none;}
		.p-d{font-size: 12px; vertical-align: text-top;}
	}
	.old-price{font-size: 14px; color: var(--black); padding-bottom: 3px; text-decoration: line-through;}
	.price-info{
		display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 11px; height: 11px; position: relative; margin-bottom: 8px;
		@media (max-width: @t){margin-bottom: 1px;}
		&:before{.icon-info(); font: 11px/1 var(--fonti); color: var(--black);}
		&:hover .price-tooltip{display: flex;}
	}
	.price-tooltip{
		display: none; align-items: center; white-space: nowrap; padding: 6px 8px; border-radius: 6px; background: var(--gray3); font-size: 11px; font-weight: normal; color: var(--black); position: absolute; right: -10px; bottom: calc(~"100% - -8px");
		&:before{.pseudo(8px,8px); background: var(--gray3); position: absolute; top: calc(~"100% - 5px"); right: 12px; z-index: 1; .rotate(45deg);}
	}
	.price-badges{width: 100%;}
	.badge{
		padding: 5px 10px; display: inline-block; font-weight: bold; background: var(--blueDark); border-radius: 4px; font-size: 12px; color: var(--white);
		&.red{background: var(--errorColor); color: #fff;}
		&.blue{background: var(--blue); color: #fff;}
		&.yellow{background: #CDD700; color: var(--blueDark);}
	}
</style>